const formValidate = () => {
	if (document.querySelector('.contact-us__form')) {
		const formEL = document.querySelector('.contact-us__form');
		const required = formEL.querySelectorAll('[required]');
		const formWrapper = document.querySelector('.contact-us');
		const capatchaEl = document.querySelector('.g-recaptcha');
		let capatchaValidated = false;

		const validateCapatcha = (capatcha) => {
			const response = capatcha.querySelector('#g-recaptcha-response').value;
			if (response.length < 3) {
				capatcha.classList.add('is-error');
				if (!capatcha.nextElementSibling.classList.contains('form__error'))
					capatcha.insertAdjacentHTML(
						'afterend',
						`<span class="form__error">${capatcha.getAttribute('data-error')}</span>`,
					);
			}
		};

		const validateEl = (element) => {
			if (!element.validity.valid) {
				element.classList.add('is-error');
				if (!element.nextElementSibling.classList.contains('form__error'))
					element.insertAdjacentHTML(
						'afterend',
						`<span class="form__error">${element.getAttribute('data-error')}</span>`,
					);
			} else {
				element.classList.remove('is-error');
				if (element.nextElementSibling.classList.contains('form__error')) element.nextElementSibling.remove();
			}
		};

		const checkRequired = () => {
			validateCapatcha(capatchaEl);
			required.forEach((element) => {
				validateEl(element);
				element.addEventListener(
					'input',
					() => {
						validateEl(element);
					},
					false,
				);
			});
		};

		const recaptchaCallback = () => {
			capatchaEl.classList.remove('is-error');
			if (capatchaEl.nextElementSibling.classList.contains('form__error')) capatchaEl.nextElementSibling.remove();
			capatchaValidated = true;
		};
		window.recaptchaCallback = recaptchaCallback;

		const postData = (form) => {
			const formData = new FormData(form);
			fetch(form.getAttribute('action'), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(Object.fromEntries(formData)),
			})
				.then((response) => response.json())
				.then((result) => {
					if (result.status === 'ok') {
						formWrapper.classList.toggle('contact-us--thanks');
					}
					if (result.status === 'is-error') {
						if (result.message) {
							form
								.querySelector('.link--more')
								.insertAdjacentHTML('beforebegin', `<span class="form__error">${result.message}</span>`);
						}
						result.errors.forEach((value) => {
							const formElement = form.querySelector(`[name=${value}]`);
							formElement.classList.add('is-error');
							formElement.insertAdjacentHTML(
								'afterend',
								`<span class="form__error">${formElement.getAttribute('data-error')}</span>`,
							);
						});
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		};

		formEL.addEventListener('submit', (event) => {
			event.preventDefault();
			checkRequired();
			if (event.target.checkValidity() && capatchaValidated) {
				postData(formEL);
				// formWrapper.classList.toggle('contact-us--thanks');
			}
		});
	}
};

export default formValidate;
